import {trackEvent} from "./plausible";

export function track404(){
    document.querySelectorAll('body.error404').forEach((body) => {
        trackEvent('404', {
            props: {
                path: document.location.pathname
            }
        })
    })
}